<template>
  <div>
    <v-menu :close-on-content-click="false" offset-x offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-badge
          bordered
          :content="
            notifications.filter(notif => notif.is_read === false).length
          "
          overlap
          :value="
            notifications.filter(notif => notif.is_read === false).length > 0
          "
        >
          <v-btn v-bind="attrs" icon v-on="on" @click="markNotificationRead">
            <v-icon>mdi-bell</v-icon>
          </v-btn>
        </v-badge>
      </template>
      <v-list class="list pb-0">
        <template v-if="notifications && notifications.length > 0">
          <div v-for="(item, index) in notifications" :key="index">
            <v-row class="pl-4 py-4" no-gutters>
              <v-col cols="11">
                <div v-if="item.text" class="text-body-2">
                  {{ item.text }}
                </div>
                <div
                  v-if="item.date_created"
                  class="text-caption font-weight-thin"
                >
                  {{
                    $moment(item.date_created)
                      .startOf('second')
                      .fromNow()
                  }}
                </div>
              </v-col>
              <v-col v-if="!item.date_read" cols="auto">
                <v-icon color="primary" size="small">mdi-brightness-1</v-icon>
              </v-col>
            </v-row>
          </div>
        </template>
        <div v-else class="pa-4 text-body-1 text-center">
          You don't have any new notifications
        </div>

        <v-btn
          block
          class="text-center py-2 primary--text"
          elevation="0"
          :to="{ name: 'Notifications' }"
        >
          View All Notifications
        </v-btn>
      </v-list>
    </v-menu>
    <v-snackbar v-model="snackbar" right :timeout="3000" top>
      <span>{{ snackbarText }}</span>
    </v-snackbar>
  </div>
</template>

<script>
import api from '@/api'

import { onMessage } from '@/utils/firebase'

export default {
  name: 'Notification',

  data: () => ({
    notifications: [],
    snackbar: false,
    snackbarText: '',
  }),

  mounted() {
    this.getNotifications()
    this.getRealTimeNotifications()
  },

  methods: {
    async getNotifications() {
      try {
        const res = await api.notifications.list({
          params: {
            page: 1,
            size: 5,
          },
        })

        this.notifications = res.data.data.notifications
      } catch (error) {
        console.error(error)
      }
    },

    getRealTimeNotifications() {
      onMessage(payload => {
        console.info(`> Notification Recieved: ${payload.notification.body}`)
        this.notifications = [
          {
            title: payload.notification.title,
            body: payload.notification.body,
            time: new Date(),
            is_read: false,
          },
          ...this.notifications,
        ]

        this.snackbarText = payload.notification.title
        this.snackbar = true
      }, ...this.notifications)
    },

    markNotificationRead() {
      if (this.notifications.length > 0) {
        api.notifications
          .markSeen({
            data: {
              notification_date: this.notifications[0].date_created,
              date_read: this.$moment().toISOString(),
            },
          })
          .catch(console.error)
      }
    },
  },
}
</script>

<style scoped>
.list {
  width: 400px;
}

.list > div {
  border-bottom: 1px solid #e0e0e0;
}

.view-all {
  text-align: center;
}
</style>
